import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'DynamicZoom' },
  __name: 'DynamicZoom',
  setup(__props) {



const portalLeftRef = ref('')

function getZoomLevel() {
  const htmlElement = document.documentElement
  const zoomLevel = htmlElement.getBoundingClientRect().width / htmlElement.offsetWidth
  return Number(zoomLevel.toFixed(1))
}

function adjustPortalLeftPosition(zoomLevel: number) {
  portalLeftRef.value = ''
  const portalElement = document.querySelector('[id^="q-portal--menu--"]')

  if (portalElement && portalElement.firstElementChild) {
    const firstChild = portalElement.firstElementChild

    // Add a slight delay to allow styles to be applied
    setTimeout(() => {
      let currentLeft = parseFloat(window.getComputedStyle(firstChild).left)
      const newLeft = currentLeft / (zoomLevel * 10) + currentLeft

      portalLeftRef.value = `${newLeft}px`

      console.log({ zoomLevel, currentLeft, newLeft })
    }, 1000) // 10ms delay; adjust as needed
  }
}

// Set up the MutationObserver
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    // Check if nodes were added
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && 'id' in node && (node.id as string).startsWith('q-portal--menu--')) {
          // Run your function when an element with the matching ID is added
          const zoomLevel = getZoomLevel()
          adjustPortalLeftPosition(zoomLevel)
        }
      })
    }
  }
})

// Start observing the document's body for changes
observer.observe(document.body, { childList: true, subtree: true })

watch(portalLeftRef, (newValue) => {
  const portalElement = document.querySelector('[id^="q-portal--menu--"] > div') as HTMLElement
  if (portalElement) {
    if (newValue) {
      // Set the CSS variable and add the dynamic class when portalLeftRef has a value
      portalElement.style.setProperty('--k-portal-left', newValue)
      portalElement.classList.add('k-dynamic-left')
    } else {
      // Remove the class when portalLeftRef is empty
      portalElement.classList.remove('k-dynamic-left')
    }
  }
})

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})